"use client";

import { dateBlockParts, formatDateTime } from "../lib/format";
import { useContestDisplayZone } from "../lib/display-zone";

/**
 * A contest time printed by a Server Component (`EX-PUB18`).
 *
 * The server cannot know which clock the visitor is on, so the time is the one
 * piece of an otherwise server-rendered card that has to be a client island:
 * Bangladesh time in the HTML, UTC after hydration for a visitor elsewhere.
 */
export function ContestDateTime({ iso, locale }: { iso: string | null; locale: string }) {
  const zone = useContestDisplayZone();
  if (!iso) return <>{formatDateTime(iso, locale, zone)}</>;
  return <time dateTime={iso}>{formatDateTime(iso, locale, zone)}</time>;
}

/**
 * `EX-PUB23`: a contest's day and month alone ("12 Oct"), on the visitor's
 * clock, for a figure too small to hold the whole time. A client island for
 * the reason above.
 */
export function ContestDayMonth({ iso, locale }: { iso: string; locale: string }) {
  const zone = useContestDisplayZone();
  const parts = dateBlockParts(iso, locale, zone);
  return <time dateTime={iso}>{parts ? `${parts.day} ${parts.month}` : "-"}</time>;
}
